<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card no-body>

          <!-- Titulo -->
          <div slot="header">
            <strong>CAS - Peligros</strong>
          </div>
          
          <!-- Contenido -->
          <div class="p-3">
            <b-row>
              <b-col md="10" sm="12">
                <h4><i class="el-icon-s-order mr-1"></i> <strong>Listado de peligros</strong></h4>
              </b-col>
              <b-col md="2">
                <b-button class="float-right" variant="primary" block to="/cas/crear-parametrizacion">
                  <i class="fa fa-plus fa-lg mr-1"></i>
                  Nuevo Peligro
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="12">
                <b-table bordered responsive striped hover :items="typeOfCAS" :fields="tableConfig.fields" :sort-by.sync="tableConfig.sortBy"
                  :sort-desc.sync="tableConfig.sortDesc" :sort-direction="tableConfig.sortDirection">

                  <template v-slot:cell(name)="data">{{ data.item.lista }}</template>
                  <template v-slot:cell(description)="data">{{ data.item.tagline }}</template>

                  <template v-slot:cell(action)="data">
                    <b-button variant="light" size="sm" @click="onHandleOpenModalToEditDanger(data.item)">
                      <i class="fa fa-edit"></i>
                      Editar
                    </b-button>
                    <b-button variant="outline-primary" class="ml-2" size="sm" :to="`/cas/peligros/${data.item.id}`">
                      <i class="fa fa-list"></i>
                      Ver componentes
                    </b-button>
                  </template>

                </b-table>
              </b-col>
            </b-row>
          </div>

        </b-card>
      </b-col>
    </b-row>

    <!-- Modal para ver detalles del Peligro -->
    <ModalEditDangerCAS ref="modalEditDangerCASRef" />

  </div>
</template>

<script>

// Importaciones generales
import { mapActions, mapMutations, mapState } from 'vuex'

// Componentes
import ModalEditDangerCAS from './fragments/ModalEditDanger.vue'

export default {

  name: 'cas-parametrizacion',

  components: {
    ModalEditDangerCAS
  },

  data: function () {
    return {
      tableConfig: {
        fields: [
          { key: 'name', label: 'Nombre peligro', sortable: true },
          { key: 'description', label: 'Frase si no existe el peligro', sortable: true },
          { key: 'action', label: 'Acciones' },
        ],
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc'
      },
    }
  },

  async created() {
    await this.listarTipoCas()
  },

  computed: {

    ...mapState('nuevocas', {
      typeOfCAS: 'tiposCas',
      controls: 'controles',
      listControls: 'listaControles'
    }),

  },

  methods: {

    ...mapActions('nuevocas', [
      'listarTipoCas',
      'ListarControles',
      'actualizarCampoPeligro',
    ]),

    ...mapMutations('nuevocas', [
      'setCurrentDangerActive'
    ]),

    async actualizarCampo(campo) {
      await this.actualizarCampoPeligro(campo)
    },

    onHandleOpenModalToEditDanger(danger) {
      this.setCurrentDangerActive(danger)
      this.$refs.modalEditDangerCASRef.showModal()
    }

  },

}
</script>

<style scoped>

.tab-content col {
  border: 0 !important;
}

.tab-content {
  border: 1px solid #ebebeb !important;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    background-color: #9ba9ae !important;
}

</style>

